import { z } from "zod";

/**
 * Shared DTO cho quên/đặt lại mật khẩu (US-E2.F4-0012 / @UC0006).
 * Một nguồn sự thật cho api (S01 — validate biên) và mobile (S03 — gọi + map lỗi),
 * tránh drift (DRY). C5: schema validate tại biên tái dùng được.
 *
 * Invariant story: reset link TTL ≤ 1h + single-use + KHÔNG tiết lộ email tồn tại
 * (forgot luôn trả FORGOT_PASSWORD_GENERIC_MESSAGE giống hệt — enumeration-safe).
 */

/** Body cho POST /v1/auth/password/forgot (AC1). Chuẩn hoá email tại biên. */
export const forgotPasswordRequestSchema = z.object({
  // trim + lowercase để khớp citext @unique nhất quán với register/login.
  email: z.string().trim().toLowerCase().pipe(z.string().email()),
});

export type ForgotPasswordRequest = z.infer<typeof forgotPasswordRequestSchema>;

/**
 * Body cho POST /v1/auth/password/reset (AC3).
 * password ≥ 8 ký tự (policy đặt mật khẩu mới, khớp register); confirm phải khớp.
 */
export const resetPasswordRequestSchema = z
  .object({
    token: z.string().min(1),
    password: z.string().min(8),
    confirmPassword: z.string(),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: "Mật khẩu xác nhận không khớp",
    path: ["confirmPassword"],
  });

export type ResetPasswordRequest = z.infer<typeof resetPasswordRequestSchema>;

/**
 * Hằng message dùng chung (DRY giữa api & mobile).
 * FORGOT_PASSWORD_GENERIC_MESSAGE: enumeration-safe — KHÔNG tiết lộ email tồn tại (AC1).
 */
export const FORGOT_PASSWORD_GENERIC_MESSAGE = "Email đã được gửi nếu tài khoản tồn tại";
export const RESET_LINK_EXPIRED_MESSAGE = "Link đã hết hạn"; // AC4
export const RESET_LINK_USED_MESSAGE = "Link không còn hiệu lực"; // AC5
export const RESET_SUCCESS_MESSAGE = "Mật khẩu đã được cập nhật"; // AC3

/** Machine code ổn định, gắn vào RFC7807 problem+json `code` (AC4/AC5) để mobile map. */
export const RESET_LINK_EXPIRED_CODE = "RESET_TOKEN_EXPIRED";
export const RESET_LINK_USED_CODE = "RESET_TOKEN_USED";
